import React, { useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ScheduleIcon from '@mui/icons-material/Schedule';
import AppointmentStatusColors from '../../../consts/AppointmentStatusColors';
import shell from '../SetupWizard.module.css';
import styles from './DemoConfirmedDialog.module.css';

const FLIP_DELAY_MS = 1400;

function formatSlot(value) {
  if (!value) return '';
  const date = new Date(String(value).replace(' ', 'T'));
  if (Number.isNaN(date.getTime())) return '';
  const day = date.toLocaleDateString('pt-BR', { weekday: 'short', day: '2-digit', month: 'short' });
  const time = date.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
  return `${day} · ${time}`;
}

/**
 * Comemoração do passo de teste: a resposta "Confirmo" chegou e o atendimento
 * mudou de status na agenda. O cartão desenhado mostra a troca acontecendo.
 */
function DemoConfirmedDialog({ open, date, onClose, onPrimary, primaryLabel, saving }) {
  const [flipped, setFlipped] = useState(false);

  useEffect(() => {
    if (!open) {
      setFlipped(false);
      return undefined;
    }
    const timer = setTimeout(() => setFlipped(true), FLIP_DELAY_MS);
    return () => clearTimeout(timer);
  }, [open]);

  const colors = flipped ? AppointmentStatusColors.confirmed_by_patient : AppointmentStatusColors.scheduled;
  const slot = formatSlot(date);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      PaperProps={{ className: styles.paper }}
    >
      <div className={styles.body}>
        <span className={styles.badge}><CheckCircleIcon /></span>
        <h2 className={styles.title}>Ótimo, presença confirmada!</h2>
        <p className={styles.text}>
          A consulta foi confirmada pelo paciente e já aparece assim na sua agenda.
          Fica fácil assim, não é mesmo?
        </p>

        <div className={styles.mockup} aria-hidden="true">
          <span className={styles.mockupLabel}>Sua agenda</span>
          <div
            className={styles.card}
            style={{ background: colors.bg, borderLeftColor: colors.borderColor }}
          >
            <div className={styles.cardInfo}>
              <strong className={styles.cardTitle}>Atendimento de teste</strong>
              {slot && <span className={styles.cardTime} style={{ color: colors.timeColor }}>{slot}</span>}
            </div>
            <div className={styles.flow}>
              <span className={`${styles.status} ${styles.statusPending} ${flipped ? styles.past : ''}`}>
                <ScheduleIcon fontSize="inherit" />
                Aguardando confirmação
              </span>
              <ArrowForwardIcon className={styles.flowArrow} fontSize="small" />
              <span className={`${styles.status} ${styles.statusConfirmed} ${flipped ? styles.current : ''}`}>
                <CheckCircleIcon fontSize="inherit" />
                Confirmado
              </span>
            </div>
          </div>
        </div>

        <button
          type="button"
          className={`${shell.primaryButton} ${styles.action}`}
          onClick={onPrimary}
          disabled={saving}
        >
          {saving ? 'Salvando...' : primaryLabel}
          {!saving && <ArrowForwardIcon fontSize="small" />}
        </button>
      </div>
    </Dialog>
  );
}

export default DemoConfirmedDialog;
